var _circle, _g, _g2, _g3, _g4, _g5, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSoccerBallIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 32,
    width: 32,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15,
    fill: "none",
    strokeWidth: 2,
    stroke: "#000"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 16,
    x2: 16,
    y2: 1,
    strokeWidth: 1.5,
    stroke: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 16 6 L 10.2 2.1 A 15 15 0 0 1 21.8 2.1Z",
    fill: "#000"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(72, 16, 16)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 16,
    x2: 16,
    y2: 1,
    strokeWidth: 1.5,
    stroke: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 16 6 L 10.2 2.1 A 15 15 0 0 1 21.8 2.1Z",
    fill: "#000"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(144, 16, 16)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 16,
    x2: 16,
    y2: 1,
    strokeWidth: 1.5,
    stroke: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 16 6 L 10.2 2.1 A 15 15 0 0 1 21.8 2.1Z",
    fill: "#000"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(216, 16, 16)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 16,
    x2: 16,
    y2: 1,
    strokeWidth: 1.5,
    stroke: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 16 6 L 10.2 2.1 A 15 15 0 0 1 21.8 2.1Z",
    fill: "#000"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(288, 16, 16)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 16,
    x2: 16,
    y2: 1,
    strokeWidth: 1.5,
    stroke: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 16 6 L 10.2 2.1 A 15 15 0 0 1 21.8 2.1Z",
    fill: "#000"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 16 10 L 21.71 14.15 L 19.53 20.85 L 12.47 20.85 L 10.29 14.15",
    fill: "#000"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoccerBallIcon);
export default __webpack_public_path__ + "static/media/soccer-ball-icon.89e4cbcc2b27e01cc0f71b13f2837700.svg";
export { ForwardRef as ReactComponent };